import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-dark border-t border-gray-800 py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-10 mb-10">

          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <img src="/favicon.ico" alt="InjectAI Labs" className="w-9 h-9" />
              <span className="font-bold text-lg">InjectAI <span className="text-primary">Labs</span></span>
            </Link>
            <p className="text-gray-500 text-sm leading-relaxed max-w-xs">
              AI research company building production-ready intelligence for enterprise platforms.
            </p>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-xs uppercase tracking-widest text-gray-500 font-medium mb-4">Company</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/research" className="text-gray-400 hover:text-white transition-colors">Research</Link></li>
              <li><Link to="/integrations" className="text-gray-400 hover:text-white transition-colors">Integrations</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-white transition-colors">About</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs uppercase tracking-widest text-gray-500 font-medium mb-4">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="mailto:injectailabs.space@gmail.com" className="text-gray-400 hover:text-white transition-colors break-all">
                  injectailabs.space@gmail.com
                </a>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors">
                  Request Access
                </Link>
              </li>
            </ul>
          </div>

        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-gray-600">
          <p>&copy; {new Date().getFullYear()} InjectAI Labs. All rights reserved.</p>
          <p>Space for Innovators</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
